  <!--
   功能名称:单选按钮框
   开发人:梁高权
   创建时间:2021/03/14
   最后修改时间:2021/03/14
   -->
<template>
  <div class="GRadioButton-wrap">
    <span :class="[value==item.value?'radio':'']" v-for="(item,index) in radioList" :key="index" @click="Gradio(item.value)">{{item.title}}</span>
  </div>
</template>
<script>
export default{
  name:'GRadioButton',
  props:{
    radioList:{
      type:Array,
      default:()=>[]
    },
    value:[String, Number]
  },
  methods:{
    Gradio(value){
      this.$emit('Gradio',value)
    }
  }
}
</script>
<style lang="scss" scoped>
.GRadioButton-wrap{
  display: flex;
  justify-content: space-between;
  span{
    border: 2px solid #EEEEEE;
    border-radius: 26px;
    padding: 10px 40px;
    font-size: 24px;
    color: #666;
    font-weight: 500;
  }
  .radio{
    border-color:#691BFF;
    color: #691BFF;
  }
}
</style>
